const SvgDownload = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M25.333 12H20V4h-8v8H6.667L16 21.333zM6.667 24h18.667v2.667H6.667z" />
  </svg>;
export default SvgDownload;